import {
	LanguageContext,
	Region,
	useAllLanguages,
} from '@monthio/react-components'
import { useContext, useEffect, VoidFunctionComponent } from 'react'
import i18n from 'i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/reducers'

export const getLanguageFromRegion = (region: Region | undefined): string => {
	switch (region) {
		case 'se':
			return 'sv-SE'
		case 'no':
			return 'nb-no'
		case 'dk':
			return 'da-DK'
		case 'fi':
			return 'fi-FI'
		case 'es':
			return 'es-ES'
		case 'nl':
			return 'nl-NL'
		default:
			return 'en-GB'
	}
}

interface InitialFlowLanguageSetterProps {
	initialLanguageDetected: boolean
}

export const InitialFlowLanguageSetter: VoidFunctionComponent<
	InitialFlowLanguageSetterProps
> = ({ initialLanguageDetected }) => {
	const { updateLanguage, language } = useContext(LanguageContext)

	const regionId = useSelector(
		(state: RootState) =>
			state.authentication?.smartCheckAuthenticationDto?.regionId,
	)

	let storedLanguageSupported = true
	const { getRegionSupportedLanguageCodes } = useAllLanguages()
	if (regionId != null) {
		const supportedLanguages = getRegionSupportedLanguageCodes(regionId, 'Flow')
		storedLanguageSupported = supportedLanguages.includes(language)
	}

	useEffect(() => {
		if (regionId == null || i18n.language === 'cimode') {
			// We dont have all the information available yet, or we're in testing mode. no change
		} else if (!initialLanguageDetected || !storedLanguageSupported) {
			// User hasnt chosen a language yet, or has chosen a language not supported. choose default based on regionId
			updateLanguage(getLanguageFromRegion(regionId))
		} else {
			// User has selected a supported language, no change
		}
	}, [
		initialLanguageDetected,
		regionId,
		storedLanguageSupported,
		updateLanguage,
	])

	return null
}
